// import { useQuery } from "@tanstack/vue-query";
import http from "@/services/http";

export const ResourceService = {
  fetchResources: () => {
    return http.get("resources");
  },
};
